import axios from "axios";

const submitLead = async (payload) => {
  const url = process.env.REACT_APP_N8N_WEBHOOK_URL;
  if (!url) {
    console.error("Falta REACT_APP_N8N_WEBHOOK_URL");
    return { ok: false, data: null };
  }

  try {
    const response = await axios.post(url, payload, { timeout: 10000 });
    return { ok: response.status === 200 && response.data?.success === true, data: response.data };
  } catch (error) {
    console.error("Error al enviar el lead:", error);
    return { ok: false, data: error.response?.data ?? null };
  }
};

export default submitLead;
